import Card from "components/card";

const Widget = (props: {
  icon?: JSX.Element;
  title: string;
  subtitle: JSX.Element;
  border?: string;
}) => {
  const { icon, title, subtitle, border } = props;
  return (
    <Card extra={`!flex-row flex-grow items-center ${!border ? 'border-b-[1px]' : border } p-3`}>
      {
        icon && <div className="flex w-auto flex-row h-full mr-3">
          <span className="mt-[1px] flex text-green-900">
            {icon}
          </span>
        </div>
      }

      <div className="flex w-auto flex-col h-full">
        <p className="text-large mb-1">{title}</p>
        <h4 className="text-small">
          {subtitle}
        </h4>
      </div>
    </Card>
  );
};

export default Widget;
